// extracted by mini-css-extract-plugin
module.exports = {"right-aligned":"RemoveButton_right-aligned__0C7tF","left-aligned":"RemoveButton_left-aligned__J2K2_","remove-button":"RemoveButton_remove-button__Yu29k"};